import PersonalSettingsSpacesTableGroupRowCellPermissions from "./CellPermissions";
import PersonalSettingsSpacesTableGroupRowCellSpace from "./CellSpace";
import { PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS } from "../../../types";
import PersonalSettingsSpacesTableGroupRowCellDescription from "./CellDescription";
import { PersonalSettingsSpacesRenderGroupRowProps } from "../../../types";

export type RenderGroupRowCellProps = {
  cellId: string;
  isFirst: boolean;
  isGroupOpen?: boolean;
} & Pick<PersonalSettingsSpacesRenderGroupRowProps, "row">;

const CELL_PER_COLUMN = {
  [PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS.PERMISSIONS]:
    PersonalSettingsSpacesTableGroupRowCellPermissions,
  [PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS.DESCRIPTION]:
    PersonalSettingsSpacesTableGroupRowCellDescription,
  [PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS.SPACE]: PersonalSettingsSpacesTableGroupRowCellSpace,
};

type PersonalSettingsSpacesTableGroupRowContentProps = PersonalSettingsSpacesRenderGroupRowProps;

const PersonalSettingsSpacesTableGroupRowContent = ({
  columns,
  row,
  groupMeta,
}: PersonalSettingsSpacesTableGroupRowContentProps) => {
  const cellProps = {
    row,
    isGroupOpen: groupMeta?.isOpen,
  };

  return columns.map((column, i) => {
    const Cell = CELL_PER_COLUMN[column.id as PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS];
    const cellId = `${row.id}-${column.id}`;

    return <Cell key={cellId} cellId={cellId} isFirst={i === 0} {...cellProps} />;
  });
};

export default PersonalSettingsSpacesTableGroupRowContent;
